var set = require('regenerate')(0x60C, 0x61F, 0x640, 0x670, 0x1DF8);

set.addRange(0x61B, 0x61C).addRange(0x64B, 0x655).addRange(0x700, 0x70D).addRange(0x70F, 0x74A).addRange(0x74D, 0x74F).addRange(0x860, 0x86A);
module.exports = set;